export const tPath = 'alerts.location';
